export const loadVersions = () => {
    let dropdown = document.querySelector(".curity-versions");
    let singleVersion = document.querySelector(".curity-version");
    const firstOption = dropdown.querySelector("option").value;
    dropdown.selectedIndex = 0;

    for (let version of versions) {
        if (versions.length === 1) {
            dropdown.classList.add("hide");
            singleVersion.classList.remove("hide");
            singleVersion.innerText = `v${version}`;
        } else {
            if (version !== firstOption) {
                let option = document.createElement("option");
                option.text = version;
                dropdown.appendChild(option);
            }
        }
    }

    // Goto URL when selecting version
    function redirect(goto) {
        window.location = goto;
    }

    dropdown.onchange = function() {
        var selectedValue = this.value;

        var dropdownOptions = dropdown.querySelectorAll("option");

        for (let dropdownOption of dropdownOptions) {
            if (selectedValue == dropdownOption.value) {
                redirect(`/docs/${dropdownOption.value}/index.html`);
            }
        }
    };
};
